import styles from './Safety.module.scss';
import Image from 'next/image';
const SafetyList = () => {
    const safetyLists = [
        {
            title: 'Rigorous Ride Inspections',
            icon: '/icons/groups/inspections.png'
        },
        {
            title: 'Staff Training and Safety Protoclos',
            icon: '/icons/groups/staff.png'
        },
        {
            title: 'Clear and Visible Safety Signage',
            icon: '/icons/groups/clear.png'
        },
        {
            title: 'Emergency Response Preparedness',
            icon: '/icons/groups/emergency.png'
        },
        {
            title: 'Safety Briefings for Groups',
            icon: '/icons/groups/safety.png'
        },
    ]
    return(
        <section className={`${styles.speciality_sec} common_padding`}>
                <div className='container'>
                    <div className={`${styles.speciality_child} row align-items-center justify-content-center`}>
                        <div className={`${styles.safety_first_sec} col-md-8 common_title text-center mobile_text_center`}>
                            <h2>Safety First</h2>
                            {/* <Image src="/icons/line.svg" width={120} height={2} alt='Icon'></Image> */}
                             <div className={styles.safety_sec_content}>
                                {safetyLists.map((item) => (
                                    <div key={item.title} className={styles.safety_sec_content_card}>
                                        <Image src={item.icon} height={50} width={50} alt={item.title} />
                                        <p>{item.title}</p>
                                    </div>
                                ))}
                            </div>
                    
                        </div>
                    </div>
                </div>
        </section>
    );
}
export default SafetyList;